import { createSlice } from "@reduxjs/toolkit";

const defaultReportDetails = {
  data: [],
  onPage: 1,
  pageSize: 0,
  totalPages: 0,
  totalRecords: 0,
};

const drmReportDetailsSlice = createSlice({
  name: "drmReportDetails",
  initialState: {
    reportDetails: { ...defaultReportDetails },
    isLoading: false,
    errorMessage: undefined,
    isDownloading: false,
    downloadError: undefined,
    downloadedRows: [],
    downloadFileName: "",
  },
  reducers: {
    getDrmReportDetails: (state) => {
      state.isLoading = true;
      state.errorMessage = undefined;
      state.downloadedRows = [];
      state.downloadFileName = "";
    },
    setDrmReportDetailsSuccess: (state, action) => {
      const { data = [], onPage = 1, pageSize = 0, totalPages = 0, totalRecords = 0 } = action.payload || {};
      state.reportDetails = {
        data,
        onPage,
        pageSize,
        totalPages,
        totalRecords,
      };
      state.isLoading = false;
      state.errorMessage = undefined;
    },
    setDrmReportDetailsFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    downloadDrmReportDetails: (state) => {
      state.isDownloading = true;
      state.downloadError = undefined;
      state.downloadedRows = [];
      state.downloadFileName = "";
    },
    setDrmReportDetailsDownloadSuccess: (state, action) => {
      const { rows = [], fileName = "ReportExport" } = action.payload || {};
      state.isDownloading = false;
      state.downloadError = undefined;
      state.downloadedRows = rows;
      state.downloadFileName = fileName;
    },
    setDrmReportDetailsDownloadFailure: (state, action) => {
      state.isDownloading = false;
      state.downloadError = action.payload;
      state.downloadedRows = [];
      state.downloadFileName = "";
    },
    resetDrmReportDetails: (state) => {
      state.reportDetails = { ...defaultReportDetails };
      state.isLoading = false;
      state.errorMessage = undefined;
      state.isDownloading = false;
      state.downloadError = undefined;
      state.downloadedRows = [];
      state.downloadFileName = "";
    },
  },
});

export const {
  getDrmReportDetails,
  setDrmReportDetailsSuccess,
  setDrmReportDetailsFailure,
  downloadDrmReportDetails,
  setDrmReportDetailsDownloadSuccess,
  setDrmReportDetailsDownloadFailure,
  resetDrmReportDetails,
} = drmReportDetailsSlice.actions;

export default drmReportDetailsSlice.reducer;
